<template>
    <div>
        <div class="tabs --jsfied">
            <ul ref="tab-primary" class="-primary">
                <li @click="clicked" :key="'tab-no'+index" v-for="(tab,index) in tabs"
                    :class="[{ 'is-active': tab.isActive },'-primary-item']">
                    <!--<a :href="getHref(tab.href)" @click="selectTab(tab)"><span v-if="tab.icon" :class="`icon icon-`+tab.icon"></span>{{ tab.name }}</a>-->
                    <a :data-id="'tab-dup-no'+index" @click="selectTab(tab)"><span v-if="tab.deviceType"
                                                                                   :class="`icon icon-`+getIconName(tab.deviceType)"></span>{{
                        tab.name }}</a>
                </li>
                <li @click="moreClicked" class="-more">
                    <button ref="moreBtn" type="button" aria-haspopup="true" aria-expanded="false">
                        <span>...</span>
                    </button>
                    <ul ref="secondary" class="-secondary">
                        <li @click="clicked" :key="'tab-dupl-no'+index" v-for="(tab,index) in tabs"
                            :class="{ 'is-active': tab.isActive }">
                            <!--<a :href="getHref(tab.href)" @click="selectTab(tab)"><span v-if="tab.icon" :class="`icon icon-`+tab.icon"></span>{{ tab.name }}</a>-->
                            <a :data-id="'tab-dup-no'+index" @click="selectTab(tab)"><span v-if="tab.deviceType"
                                                                                           :class="`icon icon-`+getIconName(tab.deviceType)"></span>{{
                                tab.name }}</a>
                        </li>
                        <!-- {{this.$refs['tab-primary'].$el.innerHTML}}-->
                    </ul>
                </li>
            </ul>
        </div>

        <div class="tabs-details">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Tabs",
        data() {
            return {
                tabs: []
            };
        },

        created() {

            this.tabs = this.$children;

        },
        mounted() {
            window.addEventListener('resize', this.doAdapt);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.doAdapt)
        },
        updated() {
            this.doAdapt();
        },
        computed: {
            container() {
                return document.querySelector('.tabs');
            },
            primary() {
                return this.container.querySelector('.-primary');
            },
            primaryItems() {
                return this.container.querySelectorAll('.-primary-item');
            },
            secondary() {
                return this.container.querySelector('.-secondary');
            },
            secondaryItems() {
                return this.secondary.querySelectorAll('li');
            },
            allItems() {
                return this.container.querySelectorAll('li');
            },
            moreLi() {
                return this.primary.querySelector('.-more');
            },
            moreBtn() {
                return this.moreLi.querySelector('button');
            }
        },
        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.isActive = (tab.index == selectedTab.index);
                    if (tab.index === selectedTab.index) {
                        this.$emit('tabSelected', tab.index);
                    }
                });

            },
            getIconName(deviceType) {
                switch (deviceType.toLowerCase()) {
                    case 'online':
                        return 'device-xdigital';
                    case 'mobile':
                        return 'device-mobile';
                    case 'tablet':
                        return 'device-tablet';
                    case 'desktop':
                        return 'device-desktop';
                }
                return '';
            },
            doAdapt() {
                // reveal all items for the calculation
                this.allItems.forEach((item) => {
                    item.classList.remove('--hidden')
                });

                // hide items that won't fit in the Primary
                let stopWidth = this.moreBtn.clientWidth;
                let hiddenItems = [];
                const primaryWidth = this.primary.clientWidth;
                this.primaryItems.forEach((item, i) => {
                    if (primaryWidth >= stopWidth + item.clientWidth) {
                        stopWidth += item.clientWidth
                    } else {
                        item.classList.add('--hidden');
                        hiddenItems.push(i)
                    }
                });

                // toggle the visibility of More button and items in Secondary
                if (!hiddenItems.length) {
                    this.moreLi.classList.add('--hidden');
                    this.container.classList.remove('--show-secondary');
                    this.moreBtn.setAttribute('aria-expanded', false)
                } else {
                    this.secondaryItems.forEach((item, i) => {
                        if (!hiddenItems.includes(i)) {
                            item.classList.add('--hidden')
                        }
                    })
                }
            },
            clicked(e) {
                let el = e.target;
                while (el) {
                    if (el === this.secondary || el === this.moreBtn) {
                        return;
                    }
                    el = el.parentNode
                }
                this.container.classList.remove('--show-secondary');
                this.moreBtn.setAttribute('aria-expanded', false)
                this.doAdapt();
            },
            moreClicked(e) {
                e.preventDefault();
                this.container.classList.toggle('--show-secondary');
                this.moreBtn.setAttribute('aria-expanded', this.container.classList.contains('--show-secondary'));
            }
        }
    }
</script>

<style scoped lang="scss">
    /*  .tabs:not(:last-child) {
          margin-bottom: 1.5rem;
      }

      .tabs {
          -webkit-overflow-scrolling: touch;
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          -webkit-box-align: stretch;
          -ms-flex-align: stretch;
          align-items: stretch;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          font-size: 1rem;
          -webkit-box-pack: justify;
          -ms-flex-pack: justify;
          justify-content: space-between;
          overflow: hidden;
          overflow-x: auto;
          white-space: nowrap;
      }

      .tabs ul {
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          display: -webkit-box;
          display: -ms-flexbox;
          justify-content: center;
          display: flex;
          -webkit-box-flex: 1;
          -ms-flex-positive: 1;
          flex-grow: 1;
          -ms-flex-negative: 0;
          flex-shrink: 0;
          -webkit-box-pack: start;
          -ms-flex-pack: start;
      }

      ul {
          list-style: none;
      }

      blockquote, body, dd, dl, dt, fieldset, figure, h1, h2, h3, h4, h5, h6, hr, html, iframe, legend, li, ol, p, pre, textarea, ul {
          margin: 0;
          padding: 0;
      }

      .tabs li {
          display: block;
          background-color: #fff;
          margin-right: 1.5rem;
          padding-left: 4em;
          padding-right: 4em;
      }

      @media (min-width: 768px) and (max-width: 1024px) {
          .tabs li {
              padding-left: 2em;
              padding-right: 2em;
          }
      }

      .tabs a {
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          color: #4a4a4a;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          margin-bottom: -1px;
          padding: .8em 1em;
          vertical-align: top;
          font-size: .9em;
          font-weight: bold;
      }

      .tabs a:hover {
          color: #363636;
      }

      a {
          text-decoration: none;
      }

      .tabs li.is-active {
          background-color: #ecedef;
      }

      .icon:before {
          font-size: 2em;
          margin-right: .5em;
          color: $pink;
      }

      ul {
          position: absolute;
          top: 303px;
      }

      @media screen and (min-width: 1025px) {
          ul {
              top: 317px;
          }
      }

      @media only screen and (max-width: 768px) {
          .tabs {
              width: 100vw;
              margin-left: -2rem;
          }

          .tabs:not(:last-child) {
              margin-bottom: 3.5rem;
          }

          .tabs ul {
              display: block;
              width: 100%;
          }

          .tabs li {
              padding: unset;
              margin: unset;
          }
      }*/

    .tabs:not(:last-child) {
        margin-bottom: 1.5rem;
    }

    /*.tabs li {
        background-color: #fff;
        margin-right: 1.5rem;
        padding-left: 4em;
        padding-right: 4em;
    }*/

    // ==================================================================================================================================================
    // ==================================================================================================================================================
    // ==================================================================================================================================================
    // ==================================================================================================================================================
    // ==================================================================================================================================================


    $color-bg: #fff;
    $color-bg-active: #ecedef;

    .icon:before {
        font-size: 2em;
        margin-right: .5em;
        color: $pink;
    }


    a {
        text-decoration: none;
        font-size: .9em;
        font-weight: bold;
        color: #4a4a4a;
    }

    button {
        cursor: pointer;
        border: 0;
        padding: 0;
    }

    // tabs


    .tabs {
        position: relative;

        &:not(.--jsfied) {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
        }

        // shared

        .--hidden {
            display: none;
        }

        a,
        button {
            width: 100%;
            height: 100%;
            display: block;
            font-size: 1em;
            line-height: 1.2;
            text-align: center;
            background-color: transparent;
            padding-left: 4em;
            padding-right: 4em;
        }

     /*   li.is-active > a {
            background-color: $color-bg-active;
        }*/

        li {
            max-width: 20em;
            list-style: none;
        }

        ul {
            padding-inline-start: 0;
        }

        li.is-active a{
            background-color: #ecedef;
        }

        // primary

        .-primary {
            display: flex;
            li.is-active a{
                background-color: #ecedef;
            }

            > li {
                flex-grow: 1;
                padding-right: 1em;

                > a,
                > button {
                    background-color: $color-bg;
                    white-space: nowrap;
                    cursor: pointer;
                    // padding: 1em 2.6em;

                    &:hover {
                        background-color: $color-bg-active;
                    }

                  /*  &:active {
                        background-color: $color-bg-active;
                    }*/
                }
            }

            .-more {
                padding-right: 0;
                background-color: $color-bg;

                a {
                    background-color: $color-bg;
                }

                > button span {
                    display: inline-block;
                    transition: transform 0.2s;
                }
            }

            .-more button:focus {
                outline: none !important;
            }
        }

        &.--show-secondary .-primary {
            .-more > button span {
                transform: rotate(180deg);
            }
        }

        // secondary

        .-secondary {
            max-width: 100%;
            min-width: 10em;
            display: none;
            position: absolute;
            top: 100%;
            right: 0;
            animation: nav-secondary 0.2s;
            z-index: 100;

            &:hover {
                background-color: $color-bg-active;
            }

            li.is-active a{
                background-color: #ecedef;
            }

            a,
            button {
                cursor: pointer;
                background-color: $color-bg;
                padding: 0.6em 3.45em;

                &:hover {
                    background-color: $color-bg-active;
                }

              /*  &:active {
                    background-color: $color-bg-active;
                }*/
            }
        }

        &.--show-secondary .-secondary {
            display: block;
        }
    }

    // keyframes

    @keyframes nav-secondary {
        0% {
            opacity: 0;
            transform: translateY(-1em);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .tabs a {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        color: #4a4a4a;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-bottom: -1px;
        padding: .8em 5em;
        vertical-align: top;
        font-size: .9em;
        font-weight: bold;
    }

    @media only screen and (max-width: 768px) {
        .tabs {
            a,
            button {
                font-size: 1em;
                padding-left: 1em;
                padding-right: 1em;
            }
        }
        .tabs a {
            padding: .4em 1em;
        }

        .tabs .-primary > li[data-v-56122326] {
            padding-right: .5em;
        }
    }




</style>